export const ServerEvents = {
    NEW_COMPANY_MESSAGE: 'NewCompanyMessage',
    HAS_APP_UPDATE: 'HasAppUpdate',
};
